module.exports = __webpack_public_path__ + "static/media/price-intelligence.b4e0bf59.svg";